import { render, staticRenderFns } from "./fbaChannel.vue?vue&type=template&id=cbc332e8&"
import script from "./fbaChannel.vue?vue&type=script&lang=js&"
export * from "./fbaChannel.vue?vue&type=script&lang=js&"
import style0 from "./fbaChannel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cbc332e8')) {
      api.createRecord('cbc332e8', component.options)
    } else {
      api.reload('cbc332e8', component.options)
    }
    module.hot.accept("./fbaChannel.vue?vue&type=template&id=cbc332e8&", function () {
      api.rerender('cbc332e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/FBA/Channel/fbaChannel.vue"
export default component.exports